import { useMixpanelIdentify } from '@/hooks/useMixpanelIdentify';

export function AppTracking() {
  useMixpanelIdentify();
  return null;
}
